import { useState, useEffect, useCallback, useRef } from 'react';

export function useTimer(lm, onExp) {
  const [r, setR] = useState(lm * 60);
  const [ex, setEx] = useState(false);
  const [active, setActive] = useState(false);
  const st = useRef(null);
  const lockedLm = useRef(lm);

  const start = useCallback(() => {
    const now = Date.now();
    st.current = now;
    lockedLm.current = lm;
    setR(lm * 60);
    setEx(false);
    try {
      localStorage.setItem('rq:timer-start', String(now));
      localStorage.setItem('rq:timer-limit', String(lm));
    } catch {}
    setActive(true);
  }, [lm]);

  const resume = useCallback(() => {
    try {
      const s = localStorage.getItem('rq:timer-start');
      const sl = localStorage.getItem('rq:timer-limit');
      if (s) {
        const t = parseInt(s, 10);
        const savedLm = sl ? parseInt(sl, 10) : lm;
        const elapsed = Math.floor((Date.now() - t) / 1000);
        if (savedLm > 0 && elapsed < savedLm * 60) {
          st.current = t;
          lockedLm.current = savedLm;
          setEx(false);
          setActive(true);
          return true;
        }
      }
    } catch {}
    return false;
  }, [lm]);

  const clear = useCallback(() => {
    st.current = null;
    setActive(false);
    try {
      localStorage.removeItem('rq:timer-start');
      localStorage.removeItem('rq:timer-limit');
    } catch {}
  }, []);

  useEffect(() => {
    const L = lockedLm.current;
    if (L <= 0 || ex || !active || !st.current) return;
    const iv = setInterval(() => {
      const e = Math.floor((Date.now() - st.current) / 1000);
      const rm = L * 60 - e;
      if (rm <= 0) {
        setEx(true);
        setR(0);
        clear();
        onExp();
        clearInterval(iv);
      } else setR(rm);
    }, 1000);
    return () => clearInterval(iv);
  }, [ex, active, onExp, clear]);

  return {
    remaining: r,
    expired: ex,
    active,
    limitMin: lockedLm.current,
    min: Math.floor(r / 60),
    sec: r % 60,
    start,
    resume,
    clear
  };
}
